import { HTMLAttributes } from 'react'

import Container from '@/components/base/container'
import Grid from '@/components/base/grid'
import Media, { MediaElement } from '@/components/base/media'
import MediaParallax from '@/components/base/media-parallax'
import Section from '@/components/base/section'

export type DoubleMediaProps = HTMLAttributes<HTMLElement> &
  Partial<{
    media_1_media: MediaElement
    media_2_media: MediaElement
  }>

const DoubleMedia = ({
  media_1_media: media_1,
  media_2_media: media_2,
  ...props
}: DoubleMediaProps) => {
  return (
    <Section {...props}>
      <Container>
        <Grid className="gap-y-gutter">
          <div className="col-span-4 md:col-span-3 lg:col-span-6">
            <MediaParallax className="relative aspect-[605/810] bg-havana">
              {(mediaRef) => (
                <Media ref={mediaRef} fill fit="cover" {...media_1} />
              )}
            </MediaParallax>
          </div>
          <div className="col-span-4 md:col-span-3 lg:col-span-6">
            <MediaParallax className="relative aspect-[605/810] bg-havana">
              {(mediaRef) => (
                <Media ref={mediaRef} fill fit="cover" {...media_2} />
              )}
            </MediaParallax>
          </div>
        </Grid>
      </Container>
    </Section>
  )
}

export default DoubleMedia
